import { render } from "./HeroListShowDetailSkill.vue?vue&type=template&id=5a67da94&scoped=true"
import script from "./HeroListShowDetailSkill.vue?vue&type=script&lang=js"
export * from "./HeroListShowDetailSkill.vue?vue&type=script&lang=js"

import "./HeroListShowDetailSkill.vue?vue&type=style&index=0&id=5a67da94&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a67da94"]])

export default __exports__